export enum ButtonSize {
  Large = 'large',
  Small = 'small',
}
